export const hasCommonElement = (arr1, arr2) => {
    if (arr1 == null || arr2 == null) {
        return false;
    }
    return arr1.some(r => arr2.includes(r));
};

// If arr3 is defined, only check for the items inside arr3
export const containsAllElements = (arr1, arr2, arr3) => {
    if (!arr1) {
        arr1 = [];
    }
    if (!arr2) {
        arr2 = [];
    }
    if (arr3 && arr3.length) {
        // If arr3 contains None, no item to check => return True
        if (arr3.includes('None')) {
            return true;
        }
        arr2 = arr2.filter(element => arr3.includes(element));
    }
    return arr2.every(element => arr1.includes(element));
}

// Sort array by prop (increasing, put null at the end)
export const sortArrayByProp = (arr, prop) => {
    return arr.sort((item1, item2) => (item2[prop] != null) - (item1[prop] != null) || item1[prop] - item2[prop]);
}

// Put all element of arr2 in middle of arr1 (position is specified by index)
export const insertArrayInArray = (arr1, arr2, index) => {
    if (!arr1) {
        return;
    }
    if (!arr2) {
        return;
    }
    if (!index || index === -1) {
        // Put at the end
        for (const item of arr2) {
            arr1.push(item)
        }
        return;
    }
    let insertIndex = index;
    for (const item of arr2) {
        arr1.splice(insertIndex, 0, item);
        insertIndex += 1;
    }
}

// Remove all items which has duplicated key in arr
// If key is undefined, treat it as primitive value instead of object
export const deduplicateArrayOfObject = (arr, key) => {
    if (!arr) {
        return [];
    }
    if (key) {
        return arr.filter((v, i, a) => a.findIndex(v2 => (v2[key] === v[key])) === i)
    } else {
        return arr.filter((v, i, a) => a.findIndex(v2 => (v2 === v)) === i)
    }
}

export const deduplicateArray = (arr) => deduplicateArrayOfObject(arr);

export const cloneArrayOfObject = (inputArr) => {
    const result = [];
    for (const item of inputArr) {
        result.push({ ...item });
    }
    return result;
}

export const filterFast = (data, ids) => {
    const mapIds = ids.reduce((acc, cur) => { acc[cur] = 1; return acc; }, {});
    return data.filter(item => mapIds[item.id] === 1);
}

export const replaceItemInList = (inputLst, newItem) => {
    if (!inputLst) {
        return [];
    }
    const index = inputLst.findIndex(item => item.id === newItem.id);
    if (index >= 0) {
        inputLst[index] = newItem;
    }
    return [...inputLst];
}

export const mergeArrayOfObject = (oldArr, updatedArr) => {
    const mapUpdatedIds = {};
    for (const item of updatedArr) {
        mapUpdatedIds[item.id] = true;
    }
    const result = updatedArr;
    for (const item of oldArr) {
        if (mapUpdatedIds[item.id]) {
            continue;
        }
        result.push(item);
    }
    return result;

}


// WEBPACK FOOTER //
// ./src/utils/array-handling.js